import React from "react";
import { useParams, useNavigate } from "react-router-dom";

function CleaningSwapListingSuccess() {
  const { listingId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={container}>
      <div style={card}>
        <div style={icon}>✔️</div>

        <h2 style={title}>Cleaning Swap Listing Activated</h2>

        <p style={text}>
          Your cleaning swap listing has been successfully created and is now
          visible to other users.
        </p>

        <div style={listingBox}>
          <strong>Listing ID:</strong> {listingId}
        </div>

        <div style={buttonRow}>
          <button
            style={primaryBtn}
            onClick={() => navigate(`/cleaning/swaps/${listingId}`)}
          >
            View Swap Listing
          </button>

          <button
            style={secondaryBtn}
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  display: "flex",
  justifyContent: "center",
  marginTop: "80px",
};

const card = {
  background: "#fff",
  padding: "40px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  maxWidth: "500px",
  width: "100%",
  textAlign: "center",
};

const icon = {
  fontSize: "48px",
  marginBottom: "10px",
};

const title = {
  color: "#2e7d32",
  marginBottom: "15px",
};

const text = {
  color: "#444",
  marginBottom: "20px",
};

const listingBox = {
  background: "#f1f8f4",
  padding: "12px",
  borderRadius: "6px",
  marginBottom: "25px",
};

const buttonRow = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
  flexWrap: "wrap",
};

const primaryBtn = {
  padding: "12px 18px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

const secondaryBtn = {
  padding: "12px 18px",
  backgroundColor: "#1976d2",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default CleaningSwapListingSuccess;